export function trim(str) {
  return String.prototype.trim.call(str);
}

export function isType(arg, type) {
  return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

/**
 * 获取微信 JS-SDK 签名 URL，避免 code/state 等参数触发 WAF 403
 */
export function getWechatSignUrl() {
  if (location.pathname.indexOf("/auth/") === 0) {
    return location.origin + location.pathname;
  }

  const baseUrl = location.href.split("#")[0];
  const queryIndex = baseUrl.indexOf("?");
  if (queryIndex === -1) {
    return baseUrl;
  }

  const path = baseUrl.slice(0, queryIndex);
  const blockedKeys = ["code", "state", "vconsole"];
  const params = baseUrl
    .slice(queryIndex + 1)
    .split("&")
    .filter(param => {
      const key = decodeURIComponent((param.split("=")[0] || "").toLowerCase());
      return blockedKeys.indexOf(key) === -1;
    });

  return params.length ? path + "?" + params.join("&") : path;
}

export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach(param => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

const VUE_APP_API_URL = process.env.VUE_APP_API_URL || `${location.origin}/api`;
const VUE_APP_WS_URL =
  process.env.VUE_APP_WS_URL || `ws:${location.hostname}:20003`;

export { VUE_APP_API_URL, VUE_APP_WS_URL };
